import React, { useEffect } from "react";

export default function CashBalanceTotals({
  profits,
  startBalance,
  cashBalance,
  setCashBalance,
}) {
  useEffect(() => {
    updateBalance();
  }, [startBalance, profits]);

  const updateBalance = () => {
    setCashBalance({
      month1: Number(startBalance) + Number(profits.month1),
      month2:
        Number(startBalance) + Number(profits.month1) + Number(profits.month2),
      month3:
        Number(startBalance) +
        Number(profits.month1) +
        Number(profits.month2) +
        Number(profits.month3),
      month4:
        Number(startBalance) +
        Number(profits.month1) +
        Number(profits.month2) +
        Number(profits.month3) +
        Number(profits.month4),
      month5:
        Number(startBalance) +
        Number(profits.month1) +
        Number(profits.month2) +
        Number(profits.month3) +
        Number(profits.month4) +
        Number(profits.month5),
      month6:
        Number(startBalance) +
        Number(profits.month1) +
        Number(profits.month2) +
        Number(profits.month3) +
        Number(profits.month4) +
        Number(profits.month5) +
        Number(profits.month6),
      month7:
        Number(startBalance) +
        Number(profits.month1) +
        Number(profits.month2) +
        Number(profits.month3) +
        Number(profits.month4) +
        Number(profits.month5) +
        Number(profits.month6) +
        Number(profits.month7),
      month8:
        Number(startBalance) +
        Number(profits.month1) +
        Number(profits.month2) +
        Number(profits.month3) +
        Number(profits.month4) +
        Number(profits.month5) +
        Number(profits.month6) +
        Number(profits.month7) +
        Number(profits.month8),
      month9:
        Number(startBalance) +
        Number(profits.month1) +
        Number(profits.month2) +
        Number(profits.month3) +
        Number(profits.month4) +
        Number(profits.month5) +
        Number(profits.month6) +
        Number(profits.month7) +
        Number(profits.month8) +
        Number(profits.month9),
      month10:
        Number(startBalance) +
        Number(profits.month1) +
        Number(profits.month2) +
        Number(profits.month3) +
        Number(profits.month4) +
        Number(profits.month5) +
        Number(profits.month6) +
        Number(profits.month7) +
        Number(profits.month8) +
        Number(profits.month9) +
        Number(profits.month10),
      month11:
        Number(startBalance) +
        Number(profits.month1) +
        Number(profits.month2) +
        Number(profits.month3) +
        Number(profits.month4) +
        Number(profits.month5) +
        Number(profits.month6) +
        Number(profits.month7) +
        Number(profits.month8) +
        Number(profits.month9) +
        Number(profits.month10) +
        Number(profits.month11),
      month12:
        Number(startBalance) +
        Number(profits.month1) +
        Number(profits.month2) +
        Number(profits.month3) +
        Number(profits.month4) +
        Number(profits.month5) +
        Number(profits.month6) +
        Number(profits.month7) +
        Number(profits.month8) +
        Number(profits.month9) +
        Number(profits.month10) +
        Number(profits.month11) +
        Number(profits.month12),
    });
  };

  return (
    <tr>
      <td className="alignLeft">Cash Balance</td>
      <td>{cashBalance.month1}</td>
      <td>{cashBalance.month2}</td>
      <td>{cashBalance.month3}</td>
      <td>{cashBalance.month4}</td>
      <td>{cashBalance.month5}</td>
      <td>{cashBalance.month6}</td>
      <td>{cashBalance.month7}</td>
      <td>{cashBalance.month8}</td>
      <td>{cashBalance.month9}</td>
      <td>{cashBalance.month10}</td>
      <td>{cashBalance.month11}</td>
      <td>{cashBalance.month12}</td>
    </tr>
  );
}
